/* import __COLOCATED_TEMPLATE__ from './conversation-sla-unpaused.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationSlaUnpaused from 'embercom/objects/inbox/renderable/conversation-sla-unpaused';
import LinkWithText from 'embercom/helpers/link-with-text';
import { createSafeAdminLink } from 'embercom/utils/admin-link';
import {
  truncateEventText,
  isEventTextTruncated,
  KILLSWITCH_FLAG_NAME,
} from 'embercom/lib/inbox2/event-text-truncation';

interface ConversationSlaUnpausedPart extends RenderablePart {
  renderableData: ConversationSlaUnpaused;
}

interface Args {
  part: ConversationSlaUnpausedPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsConversationSlaUnpausedComponent extends Component<Signature> {
  @service declare session: Session;

  // @ts-ignore helper doesn't seem to be typed correctly
  linkWithTextHelper = LinkWithText.create(this);

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return !this.session.workspace?.isFeatureEnabled(KILLSWITCH_FLAG_NAME);
  }

  get renderableData() {
    return this.args.part.renderableData;
  }

  get teammate() {
    return this.renderableData.adminSummary;
  }

  get slaLabel(): string {
    return this.renderableData.conversationSla.label;
  }

  get isSlaLabelTruncated(): boolean {
    return this.isConversationEventsUiImprovementsEnabled && isEventTextTruncated(this.slaLabel);
  }

  get displaySlaLabel(): string {
    if (this.isConversationEventsUiImprovementsEnabled) {
      return truncateEventText(this.slaLabel);
    }
    return this.slaLabel;
  }

  get translationKey() {
    if (this.teammate.id === this.session.teammate.id) {
      return this.isConversationEventsUiImprovementsEnabled
        ? 'inbox.conversation-sla-unpaused.you-unpaused-sla-v2'
        : 'inbox.conversation-sla-unpaused.you-unpaused-sla';
    } else {
      return this.isConversationEventsUiImprovementsEnabled
        ? 'inbox.conversation-sla-unpaused.admin-unpaused-sla-v2'
        : 'inbox.conversation-sla-unpaused.admin-unpaused-sla';
    }
  }

  get translationData() {
    if (this.teammate.id === this.session.teammate.id) {
      return {
        sla: this.displaySlaLabel,
      };
    } else {
      return {
        who: createSafeAdminLink(this.teammate, this.linkWithTextHelper),
        sla: this.displaySlaLabel,
      };
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationSlaUnpaused': typeof Inbox2ConversationStreamEventPartsConversationSlaUnpausedComponent;
    'inbox2/conversation-stream/event-parts/conversation-sla-unpaused': typeof Inbox2ConversationStreamEventPartsConversationSlaUnpausedComponent;
  }
}
